<template >
  <div :class="['steps-wrap', direction === 'vertical' ? 'is-vertical': 'is-row']">
    <slot />
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import Step from './Step'

export default {
  name: 'Steps',
  i18n,
  components: {
    Step
  },
  props: {
    direction: String,
    active: {
      type: Number,
      default: 0
    }
  },
  data () {
    console.log('steps...', this.props)
    return {}
  },
  mounted () {
    console.log('steps...', this.props)
  },
  watch: {},
  created () {
    console.log('this...', this, this.$slots)
    console.log('111....', this.$parent, this.$children)
  },
  methods: {
  }
}
</script>
<style lang="postcss">
@import 'variables';
.steps-wrap {
  display: flex;
  &.is-vertical {
    flex-direction: column;

    & .step-item {
      display: flex;
      min-height: 105px;
      box-sizing: border-box;
      position: relative;

      &:first-child {
        &::before {
          content: '';
          position: absolute;
          width: 1px;
          background-color: transparent;
          height: 9px;
          top: -2px;
          left: 6px;
        }
      }

      &:last-child {
        & .stop-left {
          & .step-line {
            background-color: transparent;
          }
        }
      }

      &::before {
        content: '';
        position: absolute;
        width: 1px;
        background-color: #9BA7BA;
        height: 9px;
        top: 0;
        left: 6px;
      }

      & .stop-left {
        display: flex;
        flex-direction: column;
        width: 12px;
        padding-top: 9px;

        & .step-num {
          width: 12px;
          height: 12px;
          line-height: 12px;
          text-align: center;
          border-radius: 100%;
          border: 1px solid #9BA7BA;
          color: #9BA7BA;
          font-size: 10px;
          box-sizing: border-box;
          background-color: #fff;
          margin-bottom: 2px;

        }

        & .step-line {
          width: 1px;
          background-color: #9BA7BA;
          display: flex;
          flex: 1 1 auto;
          margin-left: 6px;
        }
      }

      & .step-main {
        display: flex;
        flex: 1 1 auto;
        padding: 4px 8px;
      }
    }
  }
}

</style>
